module.controller('headerCtrl', ['$rootScope', '$scope', '$http', 'Session', '$state', 'baseURI','$stateParams', '$q', 'accountService', '$window', 'LimitsService', function ($rootScope, $scope, $http, Session, $state, baseURI,$stateParams, $q, accountService, $window, LimitsService){
  var user = Session.getUser();
  var limits = Session.getLimits();

  // If limits haven't loaded yet, load them
  if (!limits) {
    LimitsService.getLimits().then(function(resp){
      limits = LimitsService.setLimits(resp.data.Data);
      var subLimits = limits['SUB-CARDS'];
      if (subLimits) {
        $scope.canAddSub = (subLimits.count > 0);
      }
    });
  } else {
    var subLimits = limits['SUB-CARDS'];
    if (subLimits) {
      $scope.canAddSub = (subLimits.count > 0);
    }
  }

  var cardWidth = 225;

  // set window width, 1367 is max a header width can be
  var windowWidth = ($window.innerWidth < 1367 ? $window.innerWidth : 1367);

  $scope.cardLimit = 0;

  $scope.loading = true;

  accountService.initializeAccounts(function(err, accounts){
    if(!err){
      $scope.accounts = accounts;
      $scope.loading = false;
      for(var a in $scope.accounts){
        //if the user's account is not verified show a generic card image
        if(Session.getEnrollmentErrorCode() === 150){
          $scope.accounts[a].designId = 'default';
          $scope.accounts[a].cardStyle = 'dark';
        }
      }
      renderHeaderCards();
    }
  });

  function renderHeaderCards(){
    var selectedIndex;

    var cardLimit = Math.floor(windowWidth / cardWidth);
    // subtract 1 from limits to make room for "view all cards"
    cardLimit = cardLimit - 1;

    if($scope.accounts.length < cardLimit){
      // Is there an add sub card widget to display?
      var user = Session.getUser();
      //if the user's account is not verified then they cannot add additonal sub cards
      if ($rootScope.hasMainAccess && Session.getEnrollmentErrorCode() === 0) {
        $scope.showCanAddSub = true;
      }
      cardLimit = cardLimit - 1;
    }

    // get the current selected account index
    for(var a in $scope.accounts){

      if($scope.accounts[a].username == $stateParams.username){
        selectedIndex = Number(a);
        break;
      }

    }
    // get the row the selected account is in
    var accountRowStart = Math.floor(selectedIndex / cardLimit) * cardLimit;
    // splice $scope.accounts showing current selected row
    $scope.accountsInRow = $scope.accounts.splice(accountRowStart, cardLimit);
    // update carLimit
    $scope.cardLimit = cardLimit;
  }

  $scope.hideAccountAttribute = function(){
    //hide the account balance if the account isn't verified yet
    if(Session.getEnrollmentErrorCode() === 150){
      return true;
    }
    return false;
  };

  $scope.navToViewAllCards = navToViewAllCards;

  function navToViewAllCards(){
    $state.go('viewAllCards');
  }

}]);
